<div class="offerwrapper acvis-elevation" (dragover)="dragOver($event)" (drop)="dropp($event)">
    <div class="offerheader">
        <span multilang class="offerheadertext"><b>Angebot Nr. {{index}}</b> Kreuzfahrten</span>
        <ng-container *ngIf="currentCustomer?.asPartner">
            <div class="actions">
                <mat-icon class="rmico mr3" (click)="setCommentModal()" matTooltip="Extra info">comment
                </mat-icon>
                <button [draggable]="true" class="drg mr3" matTooltip="Position ändern"
                    (dragstart)="dragStart($event, index)">
                    <svg _ngcontent-soh-c164="" width="24px" fill="currentColor" viewBox="0 0 24 24">
                        <path _ngcontent-soh-c164=""
                            d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                        </path>
                        <path _ngcontent-soh-c164="" d="M0 0h24v24H0z" fill="none"></path>
                    </svg>
                </button>
                <mat-icon class="rmico" (click)="removeFromListF()" matTooltip="Angebot löchen">cancel
                </mat-icon>
            </div>
        </ng-container>
    </div>
    <div class="offerbody" *ngIf="catalog">
        <div class="offerimgwrapper">
            <img *ngIf="catalog?.ship?.[0]?.image?.length > 0" src="{{catalog?.ship?.[0]?.image}}"
                class="lazyload offerimg" alt="{{catalog.ship?.[0].name}}">
        </div>

        <div class="offerOperator">
            <img *ngIf="catalog.provider[0]?.logo?.length > 0" src="{{catalog.provider[0]?.logo}}"
                class="lazyload ccimg" alt="{{catalog.provider?.[0]?.name}}">
            <span multilang style="font-weight: 500;">{{catalog.ship?.[0].name}}</span>
        </div>
        <div class="offerschedule">
            <mat-icon class="unsetico">event</mat-icon>
            <span multilang class="offerscheduletext">
                <b>{{catalog.schedule?.[0]?.cruise_duration + ' Nächte'}}</b>
                {{catalog.schedule?.[0]?.cruise_start_date | date}} - {{catalog.schedule?.[0]?.cruise_end_date | date}}
            </span>
        </div>
        <div class="offerinfos">
            <div class="infobody">
                <div class="offerinfodet">
                    <mat-icon class="infoc">flag</mat-icon>
                    <span multilang style="margin-left: .3rem;">
                        <ng-container
                            *ngIf="catalog?.itineraries?.[0]?.itinerary_end_port === catalog?.itineraries?.[0]?.itinerary_start_port">
                            ab/bis
                            {{catalog?.itineraries?.[0]?.itinerary_end_port_name}}
                        </ng-container>
                        <ng-container
                            *ngIf="catalog?.itineraries?.[0]?.itinerary_end_port !== catalog?.itineraries?.[0]?.itinerary_start_port">
                            ab
                            {{catalog?.itineraries?.[0]?.itinerary_start_port_name}} bis
                            {{catalog?.itineraries?.[0]?.itinerary_end_port_name}}
                        </ng-container>
                    </span>
                </div>
                <div class="offerinfodet">
                    <mat-icon class="infoc">bedroom_child</mat-icon>
                    <span multilang style="margin-left: .3rem;">{{cabin?.name}} [{{cabin?.kabinen_code}}]</span>
                </div>
                <div class="offerinfodet">
                    <mat-icon class="infoc">restaurant</mat-icon>
                    <span multilang style="margin-left: .3rem;">{{cabin?.cruise?.board_name}}</span>
                </div>
                <div class="offerinfodet">
                    <mat-icon class="infoc">luggage</mat-icon>
                    <span multilang style="margin-left: .3rem;">Tarif: {{cabin?.preismodelcode}}</span>
                </div>
                <ng-container *ngIf="cabin?.incl_transfer === 1">
                    <div class="offerinfodet">
                        <mat-icon class="infoc">directions_bus</mat-icon>
                        <span multilang style="margin-left: .3rem;">inkl. Transfer</span>
                    </div>
                </ng-container>
                <ng-container *ngIf="cabin?.hotel?.giataid > 0">
                    <div class="offerinfodet">
                        <mat-icon class="infoc">local_hotel</mat-icon>
                        <span multilang style="margin-left: .3rem;">{{cabin?.hotel.name}} :
                            {{cabin?.hotel.tage_hotel +
                            (cabin?.hotel.tage_hotel === 1 ? 'Nacht' : ' Nächte')}}</span>
                    </div>
                </ng-container>
                <ng-container *ngIf="cabin?.incl_flight === 1 else noflight">
                    <div class="offerinfodet">
                        <mat-icon class="infoc">flight</mat-icon>
                        <span multilang style="margin-left: .3rem;max-width: calc(100% - 40px);">
                            {{cabin?.start_source_airport_name}} ({{cabin?.start_source_airport_code}}) /
                            {{cabin?.start_dest_airport_name}} ({{cabin?.start_dest_airport_code}})
                        </span>
                        <mat-icon class="infoc flgd" style="cursor:help" #tooltiflight="matTooltip"
                            (click)="tooltiflight.toggle();$event.stopPropagation();" matTooltipClass="matTooltip"
                            matTooltip="Unbekannte Flugdaten werden Ihnen rechtzeitig vor Ihrer Reise mitgeteilt.">info
                        </mat-icon>
                    </div>
                </ng-container>
                <ng-template #noflight>
                    <div class="offerinfodet prccolor">
                        <mat-icon class="infoc">flight</mat-icon>
                        <span multilang style="margin-left: .3rem;">ohne Flüge</span>
                    </div>
                </ng-template>
                <ng-container *ngIf="booking?.promo_code?.length > 0 else promoinfo">
                    <div class="promoinfo" [matTooltip]="booking?.promo_description" matTooltipClass="matTooltip"
                        #tooltips="matTooltip" (click)="tooltips.toggle();$event.stopPropagation();"
                        matTooltipPosition="above">
                        <mat-icon class="promoinfoi">info</mat-icon>
                        <span multilang style="margin-left: .3rem;">{{booking?.promo_code}}</span>
                    </div>
                </ng-container>
                <ng-template #promoinfo>
                    <div>
                        <div class="promoinfo" [matTooltip]="booking?.promo_description" matTooltipClass="matTooltip"
                            *ngIf="booking?.promo_description?.length > 0" #tooltips="matTooltip"
                            (click)="tooltips.toggle();$event.stopPropagation();" matTooltipPosition="above">
                            <mat-icon class="promoinfoi">info</mat-icon>
                            <span multilang style="margin-left: .3rem;width: 80%;">{{booking?.promo_description}}</span>
                        </div>
                    </div>
                </ng-template>
            </div>


            <div class="offerinfodet" (click)="openDetail()">
                <span multilang class="minbtn noselect" matRipple>Mehr Details</span>
            </div>
        </div>
        <div>
            <div class="offerprice" (click)="goToBooking()">
                <span multilang>{{travelerText}} <mat-icon class="infoc" style="cursor:help"
                        #tooltipsofferpack="matTooltip" (click)="tooltipsofferpack.toggle();$event.stopPropagation();"
                        matTooltipClass="matTooltip" [matTooltip]="prcdetail">info
                    </mat-icon></span>
                <div class="offerpriceTotal">
                    <span multilang>Gesamtpreis:</span>
                    <span multilang *ngIf="booking?.pricedetails?.provider?.length > 0"
                        class="prccolor">{{booking.pricedetails.provider[0].total | number:'1.2-2'}} EUR</span>
                </div>
            </div>
            <div class="mhrd">
                @if(loading()) {
                <mat-spinner diameter="20"></mat-spinner>
                } @else {
                @if(booking?.success) {
                <div class="noselect bookingbtn" (click)="goToBooking()">
                    Buchen
                </div>
                } @else {
                <div class="noselect alternativebtn" (click)="gotoOffers()">
                    Ausgebucht, bitte alternative beachten
                </div>
                }
                }
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="showDetail">
    <clever-offerpackdetailmodal (triggerCloseModal)="closeModal($event)"
        [cmpRef]="component"></clever-offerpackdetailmodal>
</ng-container>